<template>
  <div id="app">
   <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
   <router-view></router-view>
  </div>
</template>

<script>

import HelloWorld from './components/HelloWorld.vue'
import NewPage from './components/login.vue' // 引入新页面组件
export default {
  name: 'app',
  components: {
    NewPage
  }
}
</script>

<style>

</style>
